module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-big-cyan-ea299b5343b7b5ff2caf23780fd864a7.svg";